import type { BufferedChangeset } from "ember-changeset/types";
import type Patient from "parog-web/models/patient";

type EvaluationChoice = "yes" | "no" | "later" | "notEvaluated";

export function evaluatedChoice(choice: EvaluationChoice) {
  return choice == "notEvaluated" ? "yes" : choice;
}

/**
 * Sets the values that are saved when the medic validates an MRC stage change alert.
 * When the patient already has TLS, the TLS suggestion is always `yes`.
 */
export function setEvaluatedChoices(changeset: BufferedChangeset): void {
  changeset.set(
    "mrcStageUpdate",
    evaluatedChoice(changeset.get("mrcStageUpdate") as EvaluationChoice)
  );

  const tlsSuggestion = (changeset.get("patient") as Patient)?.tlsActive
    ? "yes"
    : evaluatedChoice(changeset.get("tlsSuggestion") as EvaluationChoice);
  changeset.set("tlsSuggestion", tlsSuggestion);
}
